import brochat from './brochat';
import crowchat from './crowchat';
import { AGENTS } from '../roles/rolesConfig';

/**
 * Agent Registry
 * Central registry for all available chat agents
 */

export const agentRegistry = {
  [AGENTS.BROCHAT]: brochat,
  [AGENTS.CROWCHAT]: crowchat,
};

/**
 * Get agent by ID
 * @param {string} agentId - Agent identifier
 * @returns {Object|null} - Agent module or null
 */
export const getAgent = (agentId) => {
  return agentRegistry[agentId] || null;
};

/**
 * Get agent configuration
 * @param {string} agentId - Agent identifier
 * @returns {Object|null} - Agent config or null
 */
export const getAgentConfig = (agentId) => {
  const agent = getAgent(agentId);
  return agent ? agent.config : null;
};

/**
 * Get agent API
 * @param {string} agentId - Agent identifier
 * @returns {Object|null} - Agent API or null
 */
export const getAgentApi = (agentId) => {
  const agent = getAgent(agentId);
  return agent ? agent.api : null;
};

/**
 * Get all registered agents
 * @returns {Array<Object>} - Array of agent configs
 */
export const getAllAgents = () => {
  return Object.values(agentRegistry).map(agent => agent.config);
};

export default agentRegistry;
